export const LOGO_FULL =
  "https://static.prod-images.emergentagent.com/jobs/924edeea-c50b-431c-a454-8a56fcef1743/images/30d70d79b1d5be8bc1d376aa1ac19ead1140e33f8eaf5bb3019f9a69838495e1.jpeg";
export const LOGO_ICON =
  "https://static.prod-images.emergentagent.com/jobs/924edeea-c50b-431c-a454-8a56fcef1743/images/6c8c1486a8d44983acd7c3e126d323ce0bf34731d3363e8f57e78e9318014e69.jpeg";
export const HERO_BANNER =
  "https://static.prod-images.emergentagent.com/jobs/924edeea-c50b-431c-a454-8a56fcef1743/images/5196cededffdd380e60691c54be2d50116806b4ca44cc2194fc9cf89e67ebd3f.jpeg";

export const HERO_SLIDES = [
  {
    img: "https://static.prod-images.emergentagent.com/jobs/924edeea-c50b-431c-a454-8a56fcef1743/images/2d017dcc676d50539bb5874ac32e41011dd0364c587a59f8a657f0cf70cfe4ea.jpeg",
    eyebrow: "The Season's Biggest Event",
    title: "Up to 70% OFF",
    subtitle: "Premium streetwear & everyday essentials for men",
    cta: "Shop Men",
    link: "/shop?gender=Men",
    align: "right",
  },
  {
    img: "https://static.prod-images.emergentagent.com/jobs/924edeea-c50b-431c-a454-8a56fcef1743/images/c9c679365ccd566aa64f88126f88cfce8bc76b76ee81c1176b13e950c20ff4fb.jpeg",
    eyebrow: "Celebrate Elegance",
    title: "Festive Fusion",
    subtitle: "Up to 40% off on women's ethnic & fusion wear",
    cta: "Shop Women",
    link: "/shop?gender=Women",
    align: "left",
  },
  {
    img: "https://static.prod-images.emergentagent.com/jobs/924edeea-c50b-431c-a454-8a56fcef1743/images/454a418bedc7384edf9c230ea24f402fa487d3cec909d35ee347679c48dcdf6f.jpeg",
    eyebrow: "New Spring Arrivals",
    title: "Happy Hearts, Vibrant Styles",
    subtitle: "Playful daily wear for kids — sizes 2–11 years",
    cta: "Shop Kids",
    link: "/shop?gender=Kids",
    align: "right",
  },
];

export const CATEGORIES = [
  { key: "T-Shirts", label: "T-Shirts" },
  { key: "Shirts", label: "Shirts" },
  { key: "Pants", label: "Pants" },
  { key: "Tops", label: "Tops" },
  { key: "Bottoms", label: "Bottoms" },
  { key: "Dresses", label: "Dresses" },
  { key: "Hoodies", label: "Hoodies" },
];
